import useSWRInfinite from "swr/infinite";

import { getGameTabResults } from "_services/api/feed";

import { formatFeeds, formatLiveVideoFeeds } from "../utils";

import Presentation from "./presentation";

export const getResults = async function ( params ) {
	const { searchQuery, key } = params;

	const response = await getGameTabResults.bind ( this ) ( params, searchQuery, false );

	if ( key === "videos" || key === "reels" ) {
		return formatFeeds ( response );
	}

	if ( key === "live" ) {

		return formatLiveVideoFeeds ( response );
	}

	return response;

};

const CardListData = ( { tab, data: dataList = [], search_query, gameDetails } ) => {

	// SWR API CALL
	const { data, error, size, setSize } = useSWRInfinite (
		index => {
			return { key: tab, pageNo: index + 2, searchQuery: search_query, gameId: gameDetails.id, androidPackageName: gameDetails.androidPackageName };
		},
		getResults,
		{ fallbackData: [], revalidateFirstPage: false }
	);

	// function to call API for next data in infinite call
	const getNextData = () => {
		setSize ( size + 1 );
	};

	// state for infinite call logic
	let __data                 = [].concat.apply ( [], data );
	const isLoadingInitialData = !data && !error;
	const isEmpty              = data?.[size - 1]?.length === 0;
	const isLoadingMore        = isLoadingInitialData || ( size > 0 && data && typeof data[size - 1] === "undefined" );

	return (
		<Presentation
			data       = { [ ...dataList, ...__data ] }
			fetchMore  = { getNextData }
			isDepleted = { isEmpty }
			isLoading  = { isLoadingMore }
			tab        = { tab }
		/>
	);
};

export default CardListData;
